import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { CompanyWhiteLabel_create, CompanyWhiteLabel_delete, CompanyWhiteLabel_readAll, CompanyWhiteLabel_readByTenantId, CompanyWhiteLabel_readById, CompanyWhiteLabel_update } from 'src/app/GlobalVariables';
import { CompanyWhiteLabelCreateRequestDTO, CompanyWhiteLabelDTO, CompanyWhiteLabelDeleteRequestDTO, CompanyWhiteLabelList, CompanyWhiteLabelReadByTenantIdRequestDTO, CompanyWhiteLabelReadByIdRequestDTO, CompanyWhiteLabelUpdateRequestDTO } from './white-label.interface';
import { resolveTenantUrl, tenantOverrideOptions } from 'src/app/Common/ApiConfigurationService/resolve-tenant-url.util';

@Injectable({
  providedIn: 'root'
})
export class WhiteLabelServiceService {
  constructor(private http: HttpClient) { }

    $whiteLabelDetails: BehaviorSubject<CompanyWhiteLabelDTO | null> = new BehaviorSubject<CompanyWhiteLabelDTO | null>(null);

  CompanyWhiteLabel_create(payload: CompanyWhiteLabelCreateRequestDTO): Observable<CompanyWhiteLabelDTO> {
    return this.http.post<CompanyWhiteLabelDTO>(CompanyWhiteLabel_create, payload);
  }

  CompanyWhiteLabel_update(payload: CompanyWhiteLabelUpdateRequestDTO): Observable<CompanyWhiteLabelDTO> {
    return this.http.post<CompanyWhiteLabelDTO>(CompanyWhiteLabel_update, payload);
  }

  CompanyWhiteLabel_delete(data: CompanyWhiteLabelDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(CompanyWhiteLabel_delete, data);
  }

  CompanyWhiteLabel_readAll(): Observable<CompanyWhiteLabelList> {
    return this.http.get<CompanyWhiteLabelList>(CompanyWhiteLabel_readAll);
  }

  CompanyWhiteLabel_readById(data: CompanyWhiteLabelReadByIdRequestDTO): Observable<CompanyWhiteLabelDTO> {
    return this.http.post<CompanyWhiteLabelDTO>(CompanyWhiteLabel_readById, data);
  }

  CompanyWhiteLabel_readByTenantId(data: CompanyWhiteLabelReadByTenantIdRequestDTO): Observable<CompanyWhiteLabelDTO> {
    return this.http.post<CompanyWhiteLabelDTO>(CompanyWhiteLabel_readByTenantId, data).pipe(tap((res) => { this.$whiteLabelDetails.next(res) }))
  }

    // baseUrlOverride (optional): the viewed tenant's own AM gateway origin,
    // e.g. CompanyDetailComponent.apiConfigOverride.AM. Omitted for every
    // other caller (e.g. login/shell pages using the admin's own tenant) -
    // behaves exactly as before.
    GetCompanyWhiteLabel(data: CompanyWhiteLabelReadByTenantIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<CompanyWhiteLabelDTO> {
    return this.http.post<CompanyWhiteLabelDTO>(resolveTenantUrl(CompanyWhiteLabel_readByTenantId, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0))
  }


}
